import { useRef } from 'react';

import { Cost } from '@r1-frontend/ui-react/components/costs';
import { UnorderedList } from '@r1-frontend/ui-react/components/List';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { BlockContainer, FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import SpeedLineWithDescription from '@r1-frontend/ui-react/organisms/SpeedLine/SpeedLineWithDescription';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';

import selectSpeed from '~/src/features/tariffBuilder/actions/selectSpeed';
import { useConstructorAnalytics } from '~/src/features/tariffBuilder/analytics/hooks/useConstructorAnalytics';
import { useCtxDispatch, useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import getSpeedLines from '~/src/features/tariffBuilder/selectors/getSpeedLines';
import isSpeedRestrictionByEqual100 from '~/src/features/tariffBuilder/selectors/isSpeedRestrictionByEqual100';

import * as ST from './styled';

const SpeedLineWithDescriptionContainer = (): JSX.Element => {
    const numberOfCalls = useRef(0);

    const { speedItems, startDot, isOnly100 } = useCtxSelector(state => ({
        speedItems: getSpeedLines(state),
        startDot: state.selectedSpeed,
        isOnly100: isSpeedRestrictionByEqual100(state),
    }));
    const dispatch = useCtxDispatch();

    const analytics = useConstructorAnalytics();

    const handleSpeedSelect = (indexOfSelectedElement: number) => {
        numberOfCalls.current += 1;
        if (numberOfCalls.current > 1) {
            dispatch(selectSpeed({
                id: indexOfSelectedElement,
            }));
        }
        if (numberOfCalls.current === 2) {
            // Аналитику отправляем на второй вызов обработчика, так как первый вызов происходит при монтировании компонента
            analytics.moveSpeedSlider();
        }
    };

    const [firstSpeed] = speedItems;
    const descriptionList = firstSpeed?.descriptionList;

    return (
        <>
        {isOnly100
            ? <BlockContainer
                    rounder={{
                        $radius: 32,
                    }}
                    indent={{
                        $desktop: [24],
                        $mobile: [16],
                    }}
                >
                    <FullWidthListContainer $desktop={12} $mobile={8} $direction='column'>
                        <ST.HeaderWrapper>
                            <H4 as={'h2'} $withIndent={false}>
                                {`По вашему адресу доступна только одна скорость${NBSP}–${NBSP}100${NBSP}Мбит/с`}
                            </H4>
                            <Paragraph4 $smaller $color={COLORS.TextInfo}>
                                <Cost isMonthly={true}>{500}</Cost>
                            </Paragraph4>
                        </ST.HeaderWrapper>
                        {descriptionList &&
                            <UnorderedList>
                                {descriptionList.map(description => (
                                    <Paragraph4
                                        as={'li'}
                                        key={`speedLine_description_${description}}`}
                                        dangerouslySetInnerHTML={{ __html: description }}
                                    />
                                ))}
                            </UnorderedList>
                        }
                    </FullWidthListContainer>
                </BlockContainer>
            : <SpeedLineWithDescription
                items={speedItems}
                startDot={startDot}
                onSelect={handleSpeedSelect}
                experimentalModeForConstructor={true}
            />
        }
        </>
    );
};

export default SpeedLineWithDescriptionContainer;
